module.exports = __webpack_public_path__ + "media/images/coffee-wait-a529142b.gif";